import type { ReactNode } from "react";
import type { IntlConfig } from "react-intl";

/** Tags any message can use without passing them in `values`; a call site's own `values` still win. */
export const DEFAULT_RICH_TEXT_ELEMENTS: IntlConfig["defaultRichTextElements"] =
  {
    b: (chunks: ReactNode) => <strong>{chunks}</strong>,
    bold: (chunks: ReactNode) => <strong>{chunks}</strong>,
    br: () => <br />,
    strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
  };
